// Progressive enhancement for the marketing site: entry reveals, the header's
// two faces over the hero (#3200), the animated ribbon (#3192), the dynamic
// How it works strip (#3194), the figure count-ups and, once the page is
// idle, the scroll choreography (#3201) as its own chunk. No React; the copy
// stays server-rendered and every module only decorates what is already on
// the page and stands down under reduced motion.
import { boot as bootCounter } from "@lib/marketing/counter";
import { boot as bootNav } from "@lib/marketing/nav";
import { boot as bootStrip } from "@lib/marketing/process_strip";
import { boot as bootReveal } from "@lib/marketing/reveal";
import { boot as bootRibbon } from "@lib/marketing/ribbon";

function start(): void {
  bootReveal();
  bootNav();
  const ribbons = bootRibbon();
  bootStrip();
  bootCounter();
  void ribbons.then((handles) =>
    import("@lib/marketing/choreography").then((choreography) =>
      choreography.boot({ ribbons: handles }),
    ),
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
